import common from "../common";

export function translate(key) {
    let str = key || "";
    if (str.length > 0) {
        const split = str.split(".");
        split.push(common.config.language || "en");
        let i, length, t = common.config.strings;
        for (i = 0, length = split.length; i < length; ++i) {
            t = t[split[i]];
            if (!t) break;
        }
        i === split.length && (str = t);
    }
    return str;
}

export function isFossil() {
    return navigator.platform.indexOf(/iPad/) && screen.width === 768 && screen.height === 1024;
}

export function isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
}

export function isIE11Win10() {
    return (!!window.MSInputMethodContext && !!document.documentMode) && navigator.userAgent.indexOf("Windows NT 10") !== -1;
}

export function isEdge18() {
    return navigator.userAgent.indexOf("Edge/18") !== -1;
}

export function isFacebookApp() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

export function isWebView() {
    if (PIXI.utils.isMobile.apple.device) {
        return navigator.mediaDevices == null;
    } else if (PIXI.utils.isMobile.android.device) {
        return navigator.userAgent.indexOf("wv") !== -1;
    }
    return false;
}

(function() {
    PIXI.Text.prototype.renderWebGL = function(renderer) {
        if (!this.resolution) {
            this.resolution = renderer.resolution;
            this.dirty = true;
        }
        this.updateText(true);
        PIXI.Sprite.prototype.renderWebGL.call(this, renderer);
    };
})();

(function() {
    P3.utils.TWEEN.Group.prototype.time = 0;
    P3.utils.TWEEN.Group.prototype.update = function(time, preserve) {
        this.time += window.tweendt;

        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) {
            return false;
        }
        time = time !== undefined ? time : this.time;
        while (tweenIds.length > 0) {
            this._tweensAddedDuringUpdate = {};

            for (var i = 0; i < tweenIds.length; i++) {
                var tween = this._tweens[tweenIds[i]];
                if (tween && tween.update(time) === false) {
                    tween._isPlaying = false;
                    if (!preserve) {
                        delete this._tweens[tweenIds[i]];
                    }
                }
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }

        return true;
    };

    P3.utils.TWEEN.Tween.prototype.start = function(time) {
        this._group.add(this);

        this._isPlaying = true;

        this._onStartCallbackFired = false;

        this._startTime = time !== undefined ? typeof time === 'string' ? this._group.time + parseFloat(time) : time : this._group.time;
        this._startTime += this._delayTime;

        for (var property in this._valuesEnd) {
            if (this._valuesEnd[property] instanceof Array) {
                if (this._valuesEnd[property].length === 0) {
                    continue;
                }
                this._valuesEnd[property] = [this._object[property]].concat(this._valuesEnd[property]);

            }
            if (this._object[property] === undefined) {
                continue;
            }

            this._valuesStart[property] = this._object[property];

            if ((this._valuesStart[property] instanceof Array) === false) {
                this._valuesStart[property] *= 1.0;
            }
            this._valuesStartRepeat[property] = this._valuesStart[property] || 0;
        }

        return this;
    };
})();